import { Info } from 'lucide-react';
import { Button, InfoAlert } from '@/components/ui';
import { CarouselHeader } from './CarouselHeader';
import { VideoPlaceholder } from './VideoPlaceholder';

export interface Step3WatchItAppearProps {
  onBack: () => void;
  onDone: () => void;
  onClose: () => void;
  videoSrc?: string;
}

/**
 * Step 3 — "Watch it appear". Final step before "Done" (AC 15). X closes
 * without writing dismissed state; "Done" writes completed.
 *
 * Layout mirrors Step 2 — see the note there on why "Done" is pinned outside
 * the scroll region rather than sitting at the end of it (YAR-362).
 */
export function Step3WatchItAppear({
  onBack,
  onDone,
  onClose,
  videoSrc,
}: Step3WatchItAppearProps) {
  return (
    <div className="flex flex-col max-h-[calc(85dvh)]">
      <div className="min-h-0 flex-1 overflow-y-auto flex flex-col gap-4 p-5 pb-0">
        <CarouselHeader
          stepIndex={3}
          onBack={onBack}
          onClose={onClose}
        />

        <div className="flex flex-col gap-2">
          <h2 className="text-xl font-semibold text-foreground">
            Watch it appear
          </h2>
          <p className="text-base text-foreground">
            Your forwarded email will appear in the Review tab in about a
            minute. Here&apos;s what to expect.
          </p>
        </div>

        <VideoPlaceholder
          src={videoSrc}
          ariaLabel="Forwarded email surfacing in the Review tab"
        />

        <InfoAlert icon={<Info size={16} />}>
          The first email may take a little longer to appear.
        </InfoAlert>
      </div>

      <div className="shrink-0 px-5 pt-3 pb-[max(1.25rem,env(safe-area-inset-bottom))]">
        <Button
          variant="primary"
          fullWidth
          onClick={onDone}
        >
          Done
        </Button>
      </div>
    </div>
  );
}
